
/**
 * 抽出条件のグループ1つ分。**入れ子を再帰で描くために独立させている。**
 *
 * 同じ描画を親にも持たせると片方だけ直す事故が起きるので、
 * 最上位のグループもサブグループもここを通す。
 *
 * **文言はBEが組み立てて返す。ここは受け取って並べるだけ。**
 */
import Vue, { PropType } from 'vue';
import { ExtractionConditionGroup } from '@/views/pages/dynamicList/extractionConditions';

export default Vue.extend({
  // 自己参照で再帰するため name が要る（テンプレートの
  // <extraction-condition-group> はこの名前で解決される）
  name: 'ExtractionConditionGroup',
  props: {
    group: {
      type: Object as PropType<ExtractionConditionGroup>,
      required: true,
    },
  },
});
